<script setup>
import { swalError, swalSuccess } from '@/helper';
import { create_option, get_option, update_option } from '@/services/option';
import { onMounted, ref } from 'vue';


const isLoading = ref(true)
onMounted(async()=>{
  await get_assessment_interval()
  await get_assessment_interval_text()
  isLoading.value = false
})

async function get_assessment_interval_text(){
  let response = await get_option('assessment_interval_text')
  if (response.error){
    swalError(response.result, true)
    return
  }
  if (response.result.data){
    days.value.text = response.result.data.attributes.name
    days.value.text_id = response.result.data.id
  }else{
    isNewText.value = true
  }
}

async function get_assessment_interval(){
  let response = await get_option('assessment_interval')
  if (response.error){
    swalError(response.result, true)
    return
  }
  if (response.result.data){
    days.value.val = response.result.data.attributes.name
    days.value.id = response.result.data.id
  }else{
    isNew.value = true
  }
}

const isNew = ref(false)
const isNewText = ref(false)
const days = ref({
  val: '',
  id: '',
  text: '',
  text_id: ''
})

async function update_interval(type = 'number'){
  let params = {}
  let response = ''
  
  if (type == 'number'){
    params = {
      name:  days.value.val,
      config: 'assessment_interval',
      option_type: 'assessment_interval'
    }
    if (isNew.value){
      response = await create_option(params)
    }else{
      response = await update_option(days.value.id, params)
    }
  }else{
    params = {
      name:  days.value.text,
      config: 'assessment_interval_text',
      option_type: 'assessment_interval_text'
    }
    if (isNewText.value){
      response = await create_option(params)
    }else{
      response = await update_option(days.value.text_id, params)
    }
  }
  if (response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('Information has been saved')
}

const showBtn = ref(false)
const showBtnNum = ref(false)
</script>

<template>
  <loadingCard v-if="isLoading" />
  <div v-else class="card">
    <CardHeader title="Assessment Setting"/>
    <div class="card-body">
      <div class="row">
        <div class="row">
          <div class="col-8">
            <div class="mb-3">
              <label class="form-label" for="name">Assessment Interval Sentences</label>
              <input type="text" class="form-control" 
                placeholder="Assessment interval sentences"
                v-model="days.text"
                @change="showBtn = !showBtn"
              >
              <small class="form-text">Please remark %days% for placing the number of interval days</small>
            </div>
          </div>
          <div class="col-4 row mb-3 align-content-around" v-if="showBtn">
            <button class="btn btn-light-success btn-icon me-1"
              @click="update_interval('text')"
            >
              <vue-feather type="check" size="1rem"/>
            </button>
            <button class="btn btn-light-danger btn-icon"
              @click="days.text = '', showBtn = false"
            >
              <vue-feather type="trash" size="1rem"/>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="mb-3">
              <label class="form-label" for="name">Assessment Interval</label>
              <div class="input-group">
                <input type="number" class="form-control text-end" 
                  placeholder="Number of days"
                  v-model="days.val"
                  @change="showBtnNum = !showBtnNum"
                >
                <span class="input-group-text">days</span>
              </div>
              <small class="form-text">Interval to reset assessment</small>
            </div>
          </div>
          <div class="col-4 row mb-3 align-content-around" v-if="showBtnNum">
            <button class="btn btn-light-success btn-icon me-1"
              @click="update_interval('number')"
            >
              <vue-feather type="check" size="1rem"/>
            </button>
            <button class="btn btn-light-danger btn-icon"
              @click="days.val = '', showBtnNum = false"
            >
              <vue-feather type="trash" size="1rem"/>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>